import { cloneElement, forwardRef, useImperativeHandle } from 'react';

import useLazy from '@/hooks/useLazy';
import dynamic from 'next/dynamic';

const DynamicBenefitsItemPopup = dynamic(() => import('./benefits-item-content'), { ssr: false });

const BenefitsItemPopup = forwardRef(({ children, ...rest }: any, ref) => {
  const { show, hide, visible, loaded } = useLazy();

  useImperativeHandle(ref, () => {
    return {
      show,
      hide
    };
  });

  return (
    <>
      {!!children &&
        cloneElement(children, {
          onClick: show
        })}
      {loaded && <DynamicBenefitsItemPopup {...rest} visible={visible} onCancel={hide} />}
    </>
  );
});

export default BenefitsItemPopup;
